export class myJqxTreeItem {
  label: string;
  value: string;
  type: string;
  treeid: string;
  meterid: number;
  tendanhmuc: string;
  code: string;
  constructor(_label: string, _value: string, _type: string, _treeid: string = '', _meterid: number, _tendanhmuc: string, _code: string) {
    this.label = _label;
    this.value = _value;
    this.type = _type;
    this.treeid = _treeid;
    this.meterid = _meterid;
    this.tendanhmuc = _tendanhmuc;
    this.code = _code;
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/model/tree.ts